
import React, { useState, useEffect } from 'react';
import { Button, Dropdown, DropdownButton, Modal, Spinner, Row, Col } from 'react-bootstrap';
import "react-datetime/css/react-datetime.css";
import Datetime from "react-datetime";
import { ListProvider } from '../../models/interfaces/ListProvider';
import { MatchEntry } from '../../models/interfaces/MatchEntry';
import { Match } from '../../models/interfaces/Match';
import { Resolver } from '../../models/interfaces/Resolver';
import { setDateWithTZ } from '../../helpers/setDateWithTimeZone';
import TimeZones from '../../helpers/TimeZones';
import SelectTeamDropDown from './modules/SelectTeamDropDown';
import useListProviderToArray from '../../helpers/useListProviderToArray';
import '../../components/styles/ReactDateTimePicker.css';
import { CompetitionEntry, isCompetitionEntry } from '../../models/interfaces/Competitions/CompetitionEntry';

interface Props {
    shouldShow: boolean;
    title: string;
    submitBtnText: string;

    submitFunction: (
        matchDate: Date,
        onSuccess: () => void,
        onFailure: (string) => void
    ) => void;

    hideModal: () => void;
    match: Match;
}

function sortTeams(a: CompetitionEntry, b: CompetitionEntry) {
    if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
    if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
    return 0;
}

export default function UpdateMatchCrudModal({
    shouldShow,
    title,
    submitBtnText,
    submitFunction,
    hideModal,
    match,
}: Props) {
    const [selectedDate, setSelectedDate] = useState<Date | undefined>(match.date);
    const [errorMessage, setErrorMessage] = useState<string | undefined>(undefined);
    const [loading, setLoading] = useState(false);

    const handleSubmit = () => {
        if (selectedDate) {

            setLoading(true);
            submitFunction(
                selectedDate,
                () => {
                    setLoading(false);
                    hideModal();
                },
                (error) => {
                    setLoading(false);
                    setErrorMessage(error);
                }
            );
        }
    };

    useEffect(() => {
        setSelectedDate(match.date);
    }, [match]);

    return (
        <Modal show={shouldShow} onHide={hideModal}>
            <Modal.Header closeButton onHide={hideModal}>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
               <Row>
                    <Col xs="auto">
                        <h5>Match Time</h5>
                    </Col>
                </Row>
                <Datetime
                    initialValue={selectedDate}
                    inputProps={ {placeholder:"Enter match time" }}
                    onChange={(updatedDate) => {
                        if (typeof updatedDate === 'string') {
                            setSelectedDate(undefined)
                        } else {
                            setSelectedDate(updatedDate.toDate())
                        }
                    }}    
                />
            </Modal.Body>
            <Modal.Footer>
                {errorMessage}
                <Button
                    disabled={!selectedDate}
                    onClick={handleSubmit}
                    variant="success"
                >
                    {loading ? (
                        <Spinner
                            as="span"
                            animation="border"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                        />
                    ) : (
                        submitBtnText
                    )}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
